import * as React from 'react';
import { useEffect, useState } from 'react';
import { client } from '@/sanity/client';

export const HeaderTitle: React.FC = () => {
	const [title, setTitle] = useState('');

	useEffect(() => {
		const fetchTitle = async () => {
			const data = await client.fetch(
				`*[_type == "aboutPage"][0].header.heading`,
			);
			setTitle(data);
		};

		fetchTitle();
	}, []);

	return (
		<h1 className='text-5xl leading-[80px] max-md:max-w-full max-md:text-4xl max-md:leading-10'>
			{title}
			<span className='text-white'>.</span>
		</h1>
	);
};
